import i18n from "@/i18n";
import { BaseContractVueGB } from "./BaseContractVueGB";
import  dateFilter  from "fs-pb-vue2/filters/date.filter";
import  { EscrowRequestStates } from "fs-pb-vue2/data/enums/escrowRequestStates";
import IAlertService from "fs-pb-vue2/services/alert/IAlertService";
import { container } from "@/inversify.config";
import { OperationsApi } from "fs-pb-vue2/services/api/OperationsApi";
import { OperationRequestData } from "fs-pb-vue2/data/operationRequestData";
import { DeclarationPropertiesTypes } from "fs-pb-vue2/data/enums/declarationPropertiesTypes";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import { ContractModel } from "fs-pb-vue2/models/contracts/contractModel";
import { CardModel } from "fs-pb-vue2/models/contracts/cardModel";
import { ContractsApi } from "fs-pb-vue2/services/api/ContractsApi";

/** Модель представления счета */
export class EscrowRequestVueGB extends BaseContractVueGB {

  // отображение окна отмены заявки
  showCancelModal: boolean = false;

  // Индикатор загрузки
  isLoading: boolean = false;

  // Возможность отменить заявку
  canCancel: boolean = false;

  // сервис уведомлений
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  get windowWidthCalc(): number {
    return window.innerWidth;
  }

  /**Внутреннее описание заявки */
  get description(): string {
    return this.contract.Data.EscrowRequestData.Description;
  }

  /**Дата ДУДС */
  get dateDUDS(): string {
    return dateFilter(this.contract.Data.RangeFrom, "date");
  }

  /**Номер ДУДС */
  get numberDUDS(): string {
    return this.contract.Data.Number;
  }

  /**Застройщик */
  get buildingDeveloper(): string {
    return this.contract.Data.EscrowRequestData.BuildingDeveloper;
  }

  /**Объект строительства */
  get building(): string {
    return this.contract.Data.EscrowRequestData.Building;
  }

  // Возможность перехода к оформлению
  get canConfirm(): boolean {
    return (this.contract.Data.EscrowRequestData.RequestState == EscrowRequestStates.ContractPrepared) &&
    this.contract.Data.EscrowRequestData.AcceptCatId?.trim() !== '';
  }

  // Цвет текста описания
  get descriptionColor(): string {
    if (this.contract.Data.EscrowRequestData.RequestState == EscrowRequestStates.ContractPrepared) {
      return 'gb-red';
    } else {
      return 'gb-blue';
    }
  }

  // Переход к оформлению
  confirm() {
    const operationCode = Number(this.contract.Data.EscrowRequestData.AcceptCatId);

    if (operationCode === 0)
      return

    const addInitData: Record<string, string> = {
      "Reference": this.contract.Data.ReferenceId
    };

    const queryParams = Object.entries(addInitData)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');

    this.$router.push(`/operation/0/${operationCode}?${queryParams}`)
  }

  // Отмена заявки
  async cancelEscrow() {
    debugger
    this.isLoading = true;
    try {
      const cancelCatId = this.contract.Data.EscrowRequestData.CancelCatId;
      const referenceId = this.contract.Data.ReferenceId;

      if(!cancelCatId?.trim()) {
        return
      }

      let ord = new OperationRequestData();
      ord.respondentCode = cancelCatId;
      ord.setProperty("Reference", referenceId, DeclarationPropertiesTypes.String);

      ord = await OperationsApi.executeOperationSendAsync(ord);
      this.updateContracts();
      await this.alertService.info( i18n.t("main.creditRequest.canceled").toString());
      this.$router.push('/');

    } catch (e: any) {
      this.alertService.error(e.message);
    } finally {
      this.isLoading = false;
    }
  }

  updateContracts(): void {
    this.contractsStore.addMethod(() => {
  		this.contractsStore.contracts.Contracts.map((contract: ContractModel) => {
        contract.StatementModel.isPeriod = true;
        if (contract.Cards.length > 0) {
          contract.Cards.map(async (card: CardModel) => {
            card.StatementModel.isPeriod = true;
            try {
              const res: any = await ContractsApi.getCardRest(card.Data.Id);
              if (res) {
                for (const key in res) {
                  if (res[key].Properties.SummaCode === 'AvailBalance') {
                    card.Data.Rest = res[key].Properties.CurrentSumma;
                  }
                }
              }
            } catch (e: any) {
              this.alertService.error(e.messsage);
            }
          });
        }
      });
  	});
    this.contractsStore.fetchContracts();
  }
}